import {
  LOGIN_FULFILLED,
  LOGIN_REJECTED,
  RESET_PASSWORD_REJECTED,

  RESET_PASSWORD_FULFILLED,
  GET_USER_REQUESTED,
  GET_USER_REJECTED,
  GET_USER_FULFILLED,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED,
} from './types';
import axiosInstance from '../Lib/axios';


// Login Uer
export const loginUser = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`auth/login/`, params)
      .then((response) => {
        localStorage.setItem('userKey', JSON.stringify(response.data));
        dispatch({
          type: LOGIN_FULFILLED,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: LOGIN_REJECTED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

// Forgot Password
export const forgotPassword = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`/auth/password/reset-custom/`, params)
      .then((response) => {

        dispatch({
          type: RESET_PASSWORD_FULFILLED,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: RESET_PASSWORD_REJECTED,
              data: error.response.data,
            });
          }
        }


      });
  };
};


export const getUser = (email) => (dispatch) => {
  dispatch(getUserRequested());

  axiosInstance.get('/auth/user', email)
    .then(response =>
      dispatch(getUserFulfilled(response.data))
    )
    .catch(
      error => dispatch(getUserRejected(error.response)))
}

function getUserRequested() {
  return { type: GET_USER_REQUESTED }
}

function getUserFulfilled(data) {
  return { type: GET_USER_FULFILLED, payload: data }
}

function getUserRejected(error) {
  return { type: GET_USER_REJECTED, payload: error }
}




// Reset Password list
export const newPassword = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`/auth/password/reset/confirm/`, params)
      .then((response) => {
        dispatch({
          type: RESET_PASSWORD,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: RESET_PASSWORD_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};
